<template lang="pug">
  select.form-control(@change='onSelect($event.target.value)')
    option(v-for="i in types" v-bind:value="i.id" :selected='i.id == value') {{i.name}}
</template>

<script>
export default {
  props: ['value'],
  data: () => ({
    groupType: null,
    types: [
      { id: null, name: 'Other' },
      { id: 'CMO', name: 'Contract manufacturer' },
      { id: 'DEPARTMENT', name: 'Department' },
      { id: 'FACTORY', name: 'Factory' },
      { id: 'LINE', name: 'Production line' }
    ]
  }),
  methods: {
    onSelect(groupType) {
      this.$emit('input', groupType)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/GroupTypeSelector.vue